<template>
    <div class="text-center py-5">
        <router-link :to="{name: 'orders'}" class="home-link text--primary">
            <img src="/img/logo.png" alt="Jarstol">
        </router-link>
    </div>
</template>

<script>
    export default {
        name: "HomeBar"
    }
</script>

<style lang="scss" scoped>
    @import "resources/sass/variables";

    .home-link {
        font-size: 1.8em;
    }
</style>
